var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.savvyEnabled
    ? _c(
        "div",
        { staticClass: "landing-page" },
        [
          _c("LandingHero"),
          _vm._v(" "),
          _c("CourseContents"),
          _vm._v(" "),
          _c("Motivation"),
          _vm._v(" "),
          _c("CourseListing"),
          _vm._v(" "),
          _c("GetStarted"),
          _vm._v(" "),
          _c("TeachersFaq")
        ],
        1
      )
    : _c("SavvyFlow", { attrs: { "flow-id": _vm.flowId } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }